import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { useQuery } from '@/lib/api'
import { signOut } from '@/lib/auth'

export const Route = createFileRoute('/logout')({
  component: RouteComponent,
})

// UIは持たず、サインアウトを実行して即座にログイン画面にリダイレクトする
// 画面遷移アラートとの兼ね合いで、URLを持ったページを定義している（ログアウト実行→画面遷移という順序だとキャンセルした際の挙動がおかしくなるため）
function RouteComponent() {
  const navigate = useNavigate()

  useQuery('signOut', signOut, {
    onSuccess: () => {
      navigate({
        to: '/login',
        reloadDocument: true,
        replace: true,
      })
    },
  })

  return null
}
